export enum DataSetType {
    MembershipActivity = 'membershipActivity',
    OpptyCloseDate = 'opptyCloseDate',
    OpptyCreatedDate = 'opptyCreatedDate',
    CampaignCreatedDate = 'campaignCreatedDate'
}
